import FieldsInterface from "@app/Interface/FieldsInterface";
import UserModel from "@app/Model/UserModel";

export function getTwoFactorSettingFields(currentUser: UserModel): FieldsInterface {

    let twoFactorType = "email";

    // if user already has a two factor type, then use it.
    if (currentUser.twoFactorType) {
        twoFactorType = currentUser.twoFactorType;
    }

    /**
     * Get the fields for updating the user
     */
    const twoFactorFields: FieldsInterface = {
        enableTwoFactor: {
            fieldId: "enableTwoFactor",
            formFieldId: "account-form-enableTwoFactor",
            value: currentUser.enableTwoFactor,
            label: "Enable 2FA",
            validated: "default",
            required: false,
            helperTextInvalid: ""
        },
        twoFactorType: {
            fieldId: "twoFactorType",
            formFieldId: "account-form-twoFactorType",
            value: twoFactorType,
            label: "Verification Type",
            validated: "default",
            required: false
        },
        twoFactorEmailAddress: {
            fieldId: "twoFactorEmailAddress",
            formFieldId: "account-form-email",
            value: currentUser.twoFactorEmailAddress,
            label: "Email",
            validated: "default",
            required: true,
            validateAgainst: "isEmail",
            helperTextInvalid: "Please enter a valid email address."
        },
        twoFactorPhoneNumber: {
            fieldId: "twoFactorPhoneNumber",
            formFieldId: "account-form-twoFactorPhoneNumber",
            value: currentUser.twoFactorPhoneNumber,
            label: "Phone Number",
            validated: "default",
            required: true,
            helperTextInvalid: "Please enter a valid phone number."
        }

    }

    return twoFactorFields;

}

/**
 * Get userdata for posting to middleware
 * @param currentUser 
 * @param formFields 
 * @returns 
 */
export const getUserTwoFactorDataForPost = (currentUser: UserModel, formFields: FieldsInterface): UserModel => {

    const updatedUser = { ...currentUser };

    updatedUser.enableTwoFactor = true;
    
    if (typeof formFields["twoFactorType"].value === "string") {
        updatedUser.twoFactorType = formFields["twoFactorType"].value;
    }

    if (typeof formFields["twoFactorEmailAddress"].value === "string") {
        updatedUser.twoFactorEmailAddress = formFields["twoFactorEmailAddress"].value;
    }

    if (typeof formFields["twoFactorPhoneNumber"].value === "string") {
        updatedUser.twoFactorPhoneNumber = formFields["twoFactorPhoneNumber"].value;
    }

    return updatedUser;

}
